import {
  getFinalSquareYardConversion,
  getFinalSquareMileConversion,
  getFinalSquareMeterConversion,
  getFinalSquareInchConversion,
  getFinalSquareFootConversion,
  getFinalHectareConversion,
  getFinalAcreConversion
} from "./AreaConversionTracker";

function getConversion(val, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "yd":
      result = getFinalSquareYardConversion(val, conType);
      break;
    case "mi":
      result = getFinalSquareMileConversion(val, conType);
      break;
    case "mt":
      result = getFinalSquareMeterConversion(val, conType);
      break;
    case "in":
      result = getFinalSquareInchConversion(val, conType);
      break;
    case "ft":
      result = getFinalSquareFootConversion(val, conType);
      break;
    case "he":
      result = getFinalHectareConversion(val, conType);
      break;
    case "ac":
      result = getFinalAcreConversion(val, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
